//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('paperLessProduction', {
//        templateUrl: 'views/components/views/paperLessProduction/paperLessProduction.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['stateService', 'utilityService', 'paperLessProductionService', 'logisticService', 'labourPositionService', 'operationFactoryService', 'ttGridFactory', 'rememberService', function (stateService, utilityService, paperLessProductionService, logisticService, labourPositionService, operationFactoryService, ttGridFactory, rememberService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
            
//            let variableNames = {
//                businessco_no: '',
//                factory_id: '',
//                equipment_id: '',
//                date_fom: '',
//                date_tom: '',
//                dateselector_index: ''
//            };

//            vm.model = {
//                equipmentButtons: [
//                    { id: 'erase', icon: 'fa fa-solid fa-eraser', color: 'danger', type: 'danger', onClick: () => clear('equipment_id') }
//                ],
//                setting: {},
//                selectListCompanies: [],
//                selectListFactories: [],
//                selectListEquipments: [],
//                gridReady: false
//            };

//            vm.grid = new ttGridFactory({
//                rememberId: '',
//                kendo: {
//                    height: '100%',
//                    sortable: true,
//                    aggregate: true,
//                    pager: false,
//                    selectable: false,
//                    filterable: false
//                }
//            }).setToolbar({ wrapping: true });

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadSetting() {
//                vm.model.setting = (await paperLessProductionService.getPaperLessProduction())[0];
//            }

//            async function loadCompanies() {
//                vm.model.selectListCompanies = await logisticService.listCompanies();
//            }

//            async function loadFactories() {
//                if (utilityService.validateParmsValue(vm.model.setting.businessco_no) !== true) return;

//                vm.model.selectListFactories = await labourPositionService.listSelectFactories({ businessco_no: vm.model.setting.businessco_no });
//            }

//            async function loadSelectEquipments() {
//                if (utilityService.validateParmsValue(vm.model.setting.factory_id) !== true) return;

//                vm.model.selectListEquipments = await operationFactoryService.listSelectEquipments({ factory_id: vm.model.setting.factory_id });
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region GRID PROCEDURE FUNCTION CALLS

//            async function loadGrid() {
//                if (utilityService.validateParmsValue(vm.model.setting.view_id) === true) {
//                    vm.grid.dataTask.rememberId = vm.model.setting.view_id;
//                }

//                if (utilityService.validateParmsValue(vm.model.setting.p2_datatask_keyno) === true && utilityService.validateParmsValue(vm.model.setting.businessco_no) === true && utilityService.validateParmsValue(vm.model.setting.factory_id) === true && utilityService.validateParmsValue(vm.model.setting.equipment_id, true) === true && utilityService.validateParmsValue(vm.model.setting.date_fomtom) === true) {
//                    vm.grid.dataTask.loadData = {
//                        method: vm.model.setting.p2_datatask_keyno,
//                        parameters: vm.model.setting
//                    };

//                    vm.model.gridReady = true;

//                    if (vm.grid.gridfunc !== null) vm.grid.gridfunc.read();
//                }
//            }

//            // #endregion GRID PROCEDURE FUNCTION CALLS

//            // #region REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS

//            function rememberFunc(id) {
//                Object.keys(variableNames).forEach((key) => {
//                    variableNames[key] = 'w_' + stateService.getCurrentName() + '.' + key;
//                });

//                if (utilityService.validateParmsValue(variableNames[id]) !== true) return;

//                var variableValue = null;

//                switch (id) {
//                    case 'businessco_no':
//                        if (utilityService.validateParmsValue(vm.model.setting.businessco_no) !== true) return;

//                        variableValue = vm.model.setting.businessco_no;
//                        break;
//                    case 'factory_id':
//                        if (utilityService.validateParmsValue(vm.model.setting.factory_id) !== true) return;

//                        variableValue = vm.model.setting.factory_id;
//                        break;
//                    case 'equipment_id':
//                        if (utilityService.validateParmsValue(vm.model.setting.equipment_id, true) !== true) return;

//                        variableValue = vm.model.setting.equipment_id;
//                        break;
//                    case 'date_fom':
//                        if (utilityService.validateParmsValue(vm.model.setting.date_fom) !== true) return;

//                        variableValue = vm.model.setting.date_fom;
//                        break;
//                    case 'date_tom':
//                        if (utilityService.validateParmsValue(vm.model.setting.date_tom) !== true) return;

//                        variableValue = vm.model.setting.date_tom;
//                        break;
//                    case 'dateselector_index':
//                        if (utilityService.validateParmsValue(vm.model.setting.dateselector_index) !== true) return;

//                        variableValue = vm.model.setting.dateselector_index;
//                        break;
//                    default:
//                        break;
//                }

//                return rememberService.remember(variableNames[id], variableValue);
//            }

//		    // #endregion REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS

//            // #region RESET BUTTON FUNCTION

//            function clear(id) {
//                switch (id) {
//                    case 'equipment_id':
//                        vm.model.setting.equipment_id = '';

//                        rememberFunc('equipment_id');
//                        loadGrid();
//                        break;
//                    default:
//                        break;
//                }
//            }

//            // #endregion RESET BUTTON FUNCTION

//            // #region FIELD DATE RANGE CHANGE FUNCTION

//            vm.onDateRangeChanged = function (startDate, endDate, dateInterval) {
//                vm.model.setting.date_fom = startDate;
//                vm.model.setting.date_tom = endDate;
//                vm.model.setting.dateselector_index = +dateInterval <= 0 ? vm.model.setting.dateselector_index : dateInterval;

//                if (vm.model.setting.date_fom) rememberFunc('date_fom');
//                if (vm.model.setting.date_tom) rememberFunc('date_tom');
//                if (vm.model.setting.dateselector_index) rememberFunc('dateselector_index');

//                if (vm.model.setting.date_fom && vm.model.setting.date_tom && vm.model.setting.dateselector_index) {
//                    vm.model.setting.date_fomtom = vm.model.setting.date_fom + vm.model.setting.date_tom;

//                    loadGrid();
//                }
//            }

//            // #endregion FIELD DATE RANGE CHANGE FUNCTION

//            // #region FIELD CHANGE MULTI FUNCTIONS

//            vm.onChanged = function (value, id) {
//                switch (id) {
//                    case 'businessco_no':
//                        if (utilityService.validateWatchValue(value, vm.model.setting.businessco_no) !== true) return;

//                        vm.model.setting.businessco_no = value;

//                        if (utilityService.validateParmsValue(vm.model.setting.businessco_no) !== true) return;

//                        rememberFunc('businessco_no');
//                        loadFactories();
//                        break;
//                    case 'factory_id':
//                        if (utilityService.validateWatchValue(value, vm.model.setting.factory_id) !== true) return;

//                        vm.model.setting.factory_id = value;

//                        if (utilityService.validateParmsValue(vm.model.setting.factory_id, true) !== true) return;

//                        rememberFunc('factory_id');
//                        loadSelectEquipments();
//                        loadGrid();
//                        break;
//                    case 'equipment_id':
//                        if (utilityService.validateWatchValue(value, vm.model.setting.equipment_id) !== true) return;

//                        vm.model.setting.equipment_id = value;

//                        if (utilityService.validateParmsValue(vm.model.setting.equipment_id, true) !== true) return;

//                        rememberFunc('equipment_id');
//                        loadGrid();
//                        break;
//                    default:
//                        utilityService.setValueToVariable(value);
//                        break;
//                }
//            };

//            // #endregion FIELD CHANGE MULTI FUNCTIONS

//            // #region ON INIT FUNCTION

//            vm.$onInit = async function () {
//                await loadSetting();
//                loadCompanies();
//                loadFactories();
//                loadSelectEquipments();
//                loadGrid();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
